<template>
    <SelectField
        :id="id"
        ref="field"
        v-model="inputVal"
        v-bind="$attrs"
        name-field="name"
        value-field="id"
        list-field="states"
        :options="states"
        :required="required"
        @select="$emit('select', $event)"
    >
        <template #label><slot name="label">{{$attrs.label}}</slot></template>

        <template #option="option">
            {{ option.name }}
        </template>

        <template #message="messageProps">
            <slot name="message" :message="messageProps.message" />
        </template>
    </SelectField>
</template>

<script>
    import FieldProxyMixin from "@/components/form/FieldProxyMixin"
    import { addressService } from "@/service"

    export default {
        mixins: [FieldProxyMixin],
        inheritAttrs: true,

        data() {
            return {
                states: [],
            }
        },

        created() {
            addressService.findStates().then(({ states }) => (this.states = states))
        },
    }
</script>

<style scoped></style>
